var _g, _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGroup116482(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 146,
    height: 146,
    viewBox: "0 0 146 146",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1_1044)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 16,
    width: 98,
    height: 98,
    rx: 28,
    fill: "#37393F"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M52.8333 50.7493L73.0619 65.4993L92.1665 50.7493M94.625 56.1576V74.8409C94.625 77.5945 94.6255 78.9715 94.0896 80.0233C93.6183 80.9484 92.8651 81.7003 91.94 82.1717C90.8882 82.7076 89.5124 82.7077 86.7588 82.7077H58.2421C55.4886 82.7077 54.1107 82.7076 53.059 82.1717C52.1339 81.7003 51.3823 80.9484 50.9109 80.0233C50.375 78.9715 50.375 77.5945 50.375 74.8409V56.1576C50.375 53.404 50.375 52.0273 50.9109 50.9756C51.3823 50.0505 52.1339 49.2983 53.059 48.8269C54.1107 48.291 55.4886 48.291 58.2421 48.291H86.7588C89.5124 48.291 90.8882 48.291 91.94 48.8269C92.8651 49.2983 93.6183 50.0505 94.0896 50.9756C94.6255 52.0273 94.625 53.404 94.625 56.1576Z",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1_1044",
    x: 0,
    y: 0,
    width: 146,
    height: 146,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 8
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1_1044"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1_1044",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup116482);
export default __webpack_public_path__ + "static/media/Group 11648 (2).e1fe6f96ff9f79260bf31b25b74913c6.svg";
export { ForwardRef as ReactComponent };